<template>
    <div class="first-container d-flex" :class="{ 'opacity-50': isDisabled }" :data-original-url="node.url">
        <i class="material-icons drag-handler">drag_indicator</i>
        <span class="page-title">
            {{ node.name }}
            <span v-if="node.url" class="page-url">({{ displayUrl }})</span>
        </span>
    </div>
    <div class="second-container d-flex align-items-center">
        <div class="d-flex actions-container align-items-center" :style="!node.level ? { marginRight: '24px' } : {}">
            <div class="url-options">
                <i class="material-icons copy-url" @click.prevent="copyUrl">content_copy</i>
                <a :href="displayUrl" target="_blank" class="d-flex go-to-url"><i class="material-icons">open_in_new</i></a>
            </div>
            <a :href="node.actions.edit" class="btn btn-primary me-2 d-flex edit-button">
                <span class="material-icons">mode_edit</span><span class="edit-text">Edytuj</span>
            </a>
        </div>
        <div v-if="node.level" class="dropdown">
            <button class="btn btn-sm btn-secondary action-more dropdown-toggle page-menu" type="button" data-bs-toggle="dropdown" data-boundary="window" aria-expanded="false">
                <i class="material-icons">more_vert</i>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li class="change-page-status" @click="toggleStatus">
                    <button type="button" class="dropdown-item d-flex">
                        <span class="material-icons">{{ node.isActive ? 'visibility_off' : 'visibility' }}</span>
                        <span class="text">{{ node.isActive ? 'Dezaktywuj' : 'Aktywuj' }}</span>
                    </button>
                </li>
                <li class="additional-options">
                    <a :href="node.actions.edit" class="dropdown-item d-flex edit-button">
                        <span class="material-icons">mode_edit</span><span class="edit-text text">Edytuj</span>
                    </a>
                </li>
                <li class="additional-options" @click.prevent="copyUrl">
                    <button type="button" class="dropdown-item d-flex copy-url">
                        <span class="material-icons">content_copy</span>
                        <span class="text">Kopiuj URL</span>
                    </button>
                </li>
                <li class="additional-options">
                    <a :href="displayUrl" target="_blank" class="dropdown-item d-flex go-to-url">
                        <span class="material-icons">open_in_new</span>
                        <span class="text">Otwórz w nowej karcie</span>
                    </a>
                </li>
                <li class="delete-page" :class="{ 'd-none': node.isMain }" @click="deletePage">
                    <button type="button" class="dropdown-item d-flex">
                        <span class="material-icons">delete</span>
                        <span class="text">Usuń</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
    import { computed, reactive } from 'vue';
    import { copyToClipboard } from '../components/copy-to-clipboard';

    const props = defineProps(['node', 'csrfToken']);
    const node = reactive(props.node);
    const displayUrl = node.isMain ? '/' : node.url;
    const isDisabled = computed(() => node.level && !node.isActive);

    const copyUrl = () => {
        copyToClipboard(`${window.location.origin}${displayUrl}`);
    };

    const toggleStatus = () => {
        node.isActive = !node.isActive;
        fetch(node.actions.toggleStatus, {
            method: 'POST',
            body: new URLSearchParams({ _token: props.csrfToken }),
        }).then(response => {
            if (response.redirected) {
                window.location.href = response.url;
            }
        });
    };

    const deletePage = () => {
        const el = document.getElementById('modal-delete');
        const form = document.getElementById('delete-form');
        bootstrap.Modal.getOrCreateInstance(el).show();
        el.querySelector('#modal-delete-button').onclick = async e => {
            e.preventDefault();
            form.setAttribute('action', node.actions.delete);
            form.submit();
        };
    };
</script>
